import { AfterViewChecked, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { FormConstructorContent } from 'src/app/interfaces/form-and-field.interface';
import { safelyDetectChanges } from '../../../common/app.helpers';
import { FormConstructorDataStrategy } from '../../form-constructor-data.strategy';
import { FormStateService } from '../../form-state.service';
import { FormValidationService } from '../../form-validation.service';

@Component({
  selector: 'app-form-constructor-base',
  templateUrl: './form-constructor-base.component.html',
  styleUrls: ['./form-constructor-base.component.scss'],
})
export class FormConstructorBaseComponent implements OnInit, AfterViewChecked {
  @Input({ required: true }) public formContent: FormConstructorContent;
  @Input({ required: true }) protected dataStrategy: FormConstructorDataStrategy;

  private fb = inject(UntypedFormBuilder);
  private formValidationService = inject(FormValidationService);
  private formStateService = inject(FormStateService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  public form: UntypedFormGroup = this.fb.group({});

  public ngOnInit(): void {
    this.createControls();
  }

  public ngAfterViewChecked(): void {
    safelyDetectChanges(this.changeDetectorRef);
  }

  public getValidationError(formControl: AbstractControl): string {
    return this.formValidationService.getValidationError(formControl);
  }

  public isFormValid(): boolean {
    this.formStateService.validateAllFormFields(this.form);
    return this.form.valid;
  }

  public resetForm(): void {
    this.form.reset();
    this.formStateService.onFormReset(this.form);
  }

  private createControls(): void {
    this.dataStrategy.createControls({
      form: this.form,
      formContent: this.formContent,
      fieldBuilder: this.fb,
    });
  }
}
